import { theme } from '@/styles';
import { ExhibitHallViewInfo } from '@/types';
import React from 'react';
import styled from 'styled-components';

interface IntroContentProps {
  data?: ExhibitHallViewInfo;
}

const IntroContent = ({ data }: IntroContentProps) => {
  return (
    <>
      {(data?.intro.tel || data?.intro.description) && (
        <Container>
          {data?.intro.tel && <TellText>전화번호 {data?.intro.tel}</TellText>}
          {data?.intro.description && (
            <DescriptionText>{data?.intro.description}</DescriptionText>
          )}
        </Container>
      )}
    </>
  );
};

export default IntroContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${theme.colors.neutral_colors.gray[700]};

  margin-bottom: 80px;
`;

const TellText = styled.div`
  ${theme.typography.headline6};
`;

const DescriptionText = styled.div`
  ${theme.typography.body1};
`;
